module.exports = __webpack_public_path__ + "static/media/pla_green_strew2.daa29664.png";